var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-content',[_c('el-header',{attrs:{"slot":"header","favorites":false},slot:"header"}),_c('el-alert',{attrs:{"type":"warning"}},[_vm._v(" "+_vm._s(_vm.$t('error.401_text'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }